export const TEST = "TEST"
export const PRE_REGISTER = "PRE_REGISTER"
export const REGISTER_DETAILS = "REGISTER_DETAILS"
export const PROFILE_DETAILS = "PROFILE_DETAILS"
export const PROFILE_DETAILS_LOADING = "PROFILE_DETAILS_LOADING"
export const CLIENT_ID = "CLIENT_ID"
export const CREACTOR_DETAILS = "CREACTOR_DETAILS"
export const IS_VIEW_ABOUT_US = "IS_VIEW_ABOUT_US"
export const HANDLE_PROFILE_DETAILS = "HANDLE_PROFILE_DETAILS"
export const HANDLE_IS_FIRST_TIME = "HANDLE_IS_FIRST_TIME"
export const CONSUMER_DETAILS = "CONSUMER_DETAILS"
export const IS_NEW_COMER = "IS_NEW_COMER"
export const GET_PERSONAL_DETAIL = "GET_PERSONAL_DETAIL"
export const LINKED_PERSONAL_DATA = "LINKED_PERSONAL_DATA"